module.exports = __webpack_public_path__ + "d1b38583a459a94490075cf82955c907.svg";